import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import Header from '../../components/Header';
import classNames from 'classnames';
import Footer from '../../components/Footer';
import Hero from '../../components/Hero';
import ThreeColumnModule from '../../components/ThreeColumnModule/ThreeColumnModule';
import styles from './ComparePage.module.scss';
import SelectField from '../../components/SelectField/SelectField';
import Icon from '../../components/Icon';
import {useRouter} from "next/router";


export const setGetArguments = (url, productIds) => {
    const _url = new URL(url, "https://dummy.url");

    if (productIds) {
        _url.searchParams.set("product_ids", productIds.join(","));
    } else {
        _url.searchParams.delete("product_ids");
    }

    return _url.pathname + _url.search;
};
const getInitialSelectedProductsState = (productIds) => {
    return Object.fromEntries(Object.entries(productIds).map(([id, val]) => [Number(id) + 1, val]))
}

const ComparePage = ({ settings = { header: {}, hero: {}, footer: {} }, hero = {}, threeColumnModule, categories = [], options, productAttributes = {} }) => {
    const [selectedProducts, setSelectedProducts] = useState(getInitialSelectedProductsState(Object.keys(productAttributes)))
    const router = useRouter()

    useEffect(() => {
        const selectedProductKeys = Object.values(selectedProducts)
        router.replace(setGetArguments(window.location, selectedProductKeys), undefined, {scroll: false})
    }, [selectedProducts])

    const handleProductSelect = (id, option) => {
        setSelectedProducts({...selectedProducts, [id]: option.value})
    }

    const fallback = {"icon": "", "value": "-"}
    const getValuesForKey = (key) => {
        return [1,2,3].map(pos => {
            const product = selectedProducts[pos]

            if (!product) {
                return fallback
            }

            const attributes = productAttributes[product]

            if (!attributes) {
                return fallback
            }

            return attributes[key] ? attributes[key] : fallback;
        })
    }

    return (
        <div className={styles['ComparePage']}>
            <Header {...settings.header} />
            <main>
                <div className={styles['ComparePage__Hero']}>
                    {hero && <Hero {...hero} />}
                </div>
                <div>
                    {threeColumnModule && <ThreeColumnModule {...threeColumnModule} />}
                </div>
                <div className={styles['ComparePage__Container']}>
                    <div className={styles['ComparePage__Overlay']}></div>
                    <div className={styles['ComparePage__Grid']}>
                        <div className={styles['ComparePage__Row']}>
                            <div className={styles['ComparePage__Col']}>
                                <h3 className={styles['ComparePage__Header']}>
                                    Choose product
                                </h3>
                            </div>
                            {[1, 2, 3].map(selectId => (<div className={styles['ComparePage__Col']}>
                                    <div className={styles['ComparePage__Wrapper']}>
                                        <p
                                            className={
                                                styles['ComparePage__ProductHeader']
                                            }>
                                            Product {selectId}
                                        </p>
                                        <SelectField
                                            options={options}
                                            placeHolder={'Select'}
                                            selected={selectedProducts[selectId] ? selectedProducts[selectId] : null}
                                            onChange={(o) => handleProductSelect(selectId, o)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>

                        {categories.map((field) => {
                                const classes = classNames(
                                    styles['ComparePage__Field'],
                                    {
                                        [styles['ComparePage__Field--Header']]:
                                            field.attributes.length !== 0,
                                    }
                                );

                                return (
                                    <>
                                        <div
                                            className={
                                                styles['ComparePage__Row']
                                            }>
                                            <div className={classes}>
                                                <p
                                                    className={
                                                        styles[
                                                            'ComparePage__FieldText'
                                                        ]
                                                    }>
                                                    {field.title}
                                                </p>
                                            </div>
                                            {getValuesForKey(field.pk).map((item) => (
                                                <div className={classes}>
                                                    {item.icon && (
                                                        <Icon
                                                            type={item.icon}
                                                        />
                                                    )}
                                                    <p>{item.value}</p>
                                                </div>
                                            ))}
                                        </div>

                                        {field.attributes.map((item) => (
                                            <div
                                                className={
                                                    styles['ComparePage__Row']
                                                }>
                                                <div
                                                    className={
                                                        styles[
                                                            'ComparePage__Field'
                                                        ]
                                                    }>
                                                    <p
                                                        className={
                                                            styles[
                                                                'ComparePage__FieldText'
                                                            ]
                                                        }>
                                                        {item.title}
                                                    </p>
                                                </div>
                                                {getValuesForKey(item.pk).map((item) => (
                                                    <div
                                                        className={
                                                            styles[
                                                                'ComparePage__Field'
                                                            ]
                                                        }>
                                                        {item.icon && (
                                                            <Icon
                                                                type={item.icon}
                                                            />
                                                        )}
                                                        {item.value && <p>{item.value}</p>}
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </>
                                );
                            })}
                    </div>
                </div>
            </main>

            <div className={styles['ComparePage__Footer']}>
                <Footer {...settings.footer} />
            </div>
        </div>
    );
};

ComparePage.propTypes = {
    header: PropTypes.object,
    hero: PropTypes.object,
    footer: PropTypes.object,
};

export default basePageWrap(ComparePage);
